import React, { Component } from "react";
import { Row, Col, Tabs, Table, Drawer, Button, Popover, message } from "antd";
import { MenuOutlined, PlusOutlined, MoreOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import "./JoinWork.css";
import JoinWorkAdd from "./JoinWorkAdd";
import PlusIcon from "../../svg/svgicon/PlusIcon";
import SettingIcon from "../../svg/svgicon/SettingIcon";
import ButtonLinkIcon from "../../Components/MyComponent/ButtonLinkIcon";
import FilterIcon from "../../svg/svgicon/FilterIcon";
import { API } from "../../API/API";
import ExportExcel from "../../Components/ExportExcel/ExportExcel";
import MenuVertical from "../../Components/MyComponent/MenuVertical";
import PrintComponent from "../../Components/PrintComponent/PrintComponent";
import JoinWorkToPDF from "./JoinWorkToPDF/JoinWorkToPDF";
import UserContext from "../UserContext/UserContext";

class JoinWorkList extends Component {
  static contextType = UserContext;

  state = {
    data: [],
    showNewInputForm: false,
    selectedJoinId: 0,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getJoinWorkList").then((response) => {
      if (response.status === 200) {
        this.setState({
          data: response.data.retData,
        });
      }
    });
  };
  showNewInputFormHandler = (show, joinid) => {
    this.setState({
      showNewInputForm: show,
      selectedJoinId: joinid,
    });
    if (show === false) {
      this.getData();
    }
  };
  content = (record, show) => {
    return show ? <MenuVertical istender={false} onMenuChange={(e) => this.onMenuChange(e, record)} /> : null;
  };
  onMenuChange = (e, record) => {
    if (e.key == 2) {
      this.content(record, false);
      API.get("/deleteJoinWork?joinworkid=" + record.joinworkid).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          message.success("Амжилттай устгагдлаа.");
          this.getData();
        }
      });
    } else if (e.key == 1) {
      this.showNewInputFormHandler(true, record.joinworkid);
    } else if (e.key == 4) {
      this.props.history.push(
        "/joinworkinvitation/0/" +
        record.joinworkid +
        "/" +
        false
      );
    }
  };
  render() {
    const columns = [
      {
        title: "Код",
        dataIndex: "joinworkcode",
        key: "joinworkcode",
        width: "7%",
        align: "left",
        render: (text, record) => {
          const { isAdmin, isJWAdmin } = this.context.permission;
          if (isAdmin === "1" || isJWAdmin === "1") {
            return (
              <Link
              className="link"
              key={record.joinid}
              to={`/joinworkdtl/${record.joinworkid}/${record.joinworkname}/${record.joinworkcode}/${record.departmentname}/${record.tendertypename}/${record.startdate}/${record.enddate}`}
              >
                {record.joinworkcode}
              </Link>
            );
          } else {
            return (<div>
              {record.joinworkcode}
            </div>)
          } 
        }
      },
      {
        title: "Хамтран ажиллах саналын нэр",
        dataIndex: "joinworkname",
        key: "joinworkname",
        width: "25%",
        align: "left",
      },
      {
        title: "",
        dataIndex: "option",
        key: "option",
        width: "2%",
        align: "left",
        render: (text, record) => {
          return (
            <div key={record.joinworkid}>
              <Popover
                placement="bottom"
                content={this.content(record, true)}
                trigger="click"
              >
                <Button style={{ color: "#979797" }} type="link">
                  <MoreOutlined style={{ fontSize: '120%'}} />
                </Button>
              </Popover>
            </div>
          );
        },
      },
      {
        title: "Захиалагч",
        dataIndex: "departmentname",
        key: "departmentname",
        width: "10%",
        align: "left",
      },
      {
        title: "Төрөл",
        dataIndex: "tendertypename",
        key: "tendertypename",
        width: "10%",
        align: "left",
      },
      {
        title: "Хугацаа",
        dataIndex: "dateinterval",
        key: "dateinterval",
        width: "20%",
        align: "left",
        render: (text, record) => {
          return (
            <div>
              {record.startdate} - {record.enddate}
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "joinworkcode",
        key: "joinworkcode",
        width: "7%",
        align: "left",
        render: (text, record) => {
          const { isAdmin, isJWAdmin } = this.context.permission;
          console.log("jwadmin=", isJWAdmin)
          console.log("admin=", isAdmin)
          if (isAdmin === "1" || isJWAdmin === "1") {
            return (
              <Link
                className="link"
                key={record.joinworkid}
                to={`/joinworkinvitation/${record.joinworkid}`}
              >
                дэлгэрэнгүй
              </Link>
            );
          }
          return null;
        }
      },
      {
        title: "",
        dataIndex: "invitation",
        key: "invitation",
        width: "8%",
        align: "left",
        render: (text, record) => {
          const { isAdmin, isJWAdmin } = this.context.permission;
          if (isAdmin === "1" || isJWAdmin === "1") {
            return (
              <div>
              <PrintComponent
                buttonText="Урилга татах"
                content={<JoinWorkToPDF joinworkid={record.joinworkid} />}
              />
            </div>
            );
          }
          return null;
        }

      },
    ];
    return (
      <div className="Container">
        <Row align="middle">
          <Col span={12}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">
                  Хамтран ажиллах саналын жагсаалт
                </div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              <Col>
              { (this.context.permission.isAdmin === "1" || this.context.permission.isJWAdmin === "1") ?
                <ButtonLinkIcon
                  onClick={() => this.showNewInputFormHandler(true, 0)}
                  icon={<PlusIcon />}
                  name="Хамтран ажиллах санал нэмэх"
                /> : null }
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row
              style={{ height: 56 }}
              justify="end"
              align="middle"
              gutter={[16, 16]}
            >
              <Col style={{ marginRight: 10 }}>
                <ExportExcel
                  fileName={"Хамтран ажиллах саналын жагсаалт"}
                  column={columns}
                  dataSource={this.state.data}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <div id="joinwork-list" style={{ marginRight: 15 }}>
          <Table
            dataSource={this.state.data}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            scroll={{ y: 500 }}
            pagination={false}
            rowKey="joinid"
          />
        </div>
        <Drawer
          title="Хамтран ажиллах санал нэмэх"
          width="600px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0)}
          destroyOnClose={true}
        >
          <JoinWorkAdd
            joinworkid={this.state.selectedJoinId}
            parentid={0}
            showForm={this.showNewInputFormHandler}
          ></JoinWorkAdd>
        </Drawer>
      </div>
    );
  }
}
export default withRouter(JoinWorkList);
